import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useCurrentUser } from "../lib/userInfo.js";
import { ORGANIZATION_PARAM } from "../lib/tenantLink.js";
import StartupScreen from "./StartupScreen.jsx";
import UnavailableLinkPage from "./UnavailableLinkPage.jsx";

export { ITEM_UNAVAILABLE_MESSAGE, ORGANIZATION_PARAM } from "../lib/tenantLink.js";

// Every dashboard URL is organization-bound. Resolve /v1/me before mounting
// AppContent so a link copied from another organization cannot start any of
// that organization's item hydration paths. Old links have no marker; adopt
// them into the current organization and let their resource-specific lookup
// distinguish a deleted/missing item without disclosing where it exists.
export default function TenantLinkGate({ children }) {
    const user = useCurrentUser();
    const [searchParams, setSearchParams] = useSearchParams();
    const tenantId = user?.currentTenant?.tenantId || null;
    const linkedTenantIds = searchParams.getAll(ORGANIZATION_PARAM);
    const hasOrganizationParam = linkedTenantIds.length > 0;
    const linkedTenantId = linkedTenantIds.length === 1 && linkedTenantIds[0]
        ? linkedTenantIds[0]
        : null;
    const invalidOrganizationParam = hasOrganizationParam && !linkedTenantId;

    useEffect(() => {
        if (!user || !tenantId || hasOrganizationParam) return;
        setSearchParams((current) => {
            const next = new URLSearchParams(current);
            next.set(ORGANIZATION_PARAM, tenantId);
            return next;
        }, { replace: true });
    }, [hasOrganizationParam, setSearchParams, tenantId, user]);

    if (!user) return <StartupScreen />;
    if (invalidOrganizationParam || (linkedTenantId && linkedTenantId !== tenantId)) {
        return (
            <UnavailableLinkPage
                onOpenDashboard={() => {
                    const next = new URLSearchParams();
                    if (tenantId) next.set(ORGANIZATION_PARAM, tenantId);
                    setSearchParams(next, { replace: true });
                }}
            />
        );
    }
    if (tenantId && !hasOrganizationParam) return <StartupScreen />;
    return children;
}
